const Percussion = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    color="inherit"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="m18.286 5.643-2.945 9.72 1.22 4.921c.028.082.014.15-.042.205-.028.055-.084.082-.168.082H7.01c-.084 0-.14-.027-.168-.082-.056-.054-.07-.123-.042-.205l1.22-4.921-3.408-9.72c-.028-.027-.042-.054-.042-.082 0-.601.218-1.107.652-1.517.435-.41.961-.615 1.578-.615h9.297c.617 0 1.136.205 1.557.615.42.41.63.916.63 1.517v.082zM6.8 3.88a1.73 1.73 0 0 0-1.157.41 1.586 1.586 0 0 0-.568 1.025h12.705a1.586 1.586 0 0 0-.568-1.025 1.674 1.674 0 0 0-1.115-.41H6.801zm8.077 11.524v-.123l2.86-9.474h-3.407v3.568c0 .164-.084.246-.252.246-.14 0-.21-.082-.21-.246V5.807H8.947v3.568c0 .164-.085.246-.253.246-.14 0-.21-.082-.21-.246V5.807H5.16l3.324 9.474v.123L7.348 20.12h8.666l-1.136-4.716z" />
  </svg>
);

export default Percussion;
